module.exports = __webpack_public_path__ + "static/img/calendar.e849cda.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/calendar.png
// module id = NG6P
// module chunks = 1